import React, { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link } from 'react-router-dom';
import gsap from 'gsap';

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height,
    };
}

function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(
        getWindowDimensions()
    );

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return windowDimensions;
}




const CardSlider2 = ({ data= [{}] }) => {
    const { height, width } = useWindowDimensions();
    const [slidesPerView, setSlidesPerView] = useState(1);
    const [currentSlide, setCurrentSlide] = useState(1);
    const [isAutoplayRunning, setIsAutoplayRunning] = useState(true);
    const swiperRef = useRef(null);
    useEffect(() => {
        if (width >= 320 && width < 480) {
            setSlidesPerView(1);
        } else if (width >= 480 && width < 600) {
            setSlidesPerView(2);
        } else if (width >= 600 && width < 1080) {
            setSlidesPerView(3);
        } else if (width >= 1080) {
            setSlidesPerView(4);
        } else {
            setSlidesPerView("auto");
        }
    }, [width]);

    const handlePrev = () => {
        if (swiperRef.current) swiperRef.current.swiper.slidePrev();
    };

    const handleNext = () => {
        if (swiperRef.current) swiperRef.current.swiper.slideNext();
    };

    const handlePause = () => {
        if (swiperRef.current) {
            swiperRef.current.swiper.autoplay.stop();
            setIsAutoplayRunning(false); // Update state
        }
    };

    const handlePlay = () => {
        if (swiperRef.current) {
            swiperRef.current.swiper.autoplay.start();
            setIsAutoplayRunning(true); // Update state
        }
    };

    const onSlideChange = (swiper) => {
        setCurrentSlide(swiper.activeIndex + 1);

        // Apply GSAP bounce effect
        const activeSlide = swiper.slides[swiper.activeIndex];
        gsap.fromTo(
            activeSlide,
            { x: 200, opacity: 0 },
            { x: 0, opacity: 1, duration: 1, ease: "power2.out" }
        );
       
    };

    return (
        <>
            <Swiper
                ref={swiperRef}
                modules={[Navigation, Autoplay]}
                // loop={true}
                spaceBetween={30}
                slidesPerView={1}
                autoplay={{ delay: 3000 }}
                navigation={{ prevEl: ".swiper-button-prev", nextEl: ".swiper-button-next" }}
                onSlideChange={onSlideChange}
                className="swiper-container p-0 m-0"
                style={{ maxWidth: "90vw" }}
            >
                {
                    data?.map((item, index) => (
                        <SwiperSlide key={index} className="feature-slider-card">
                            <div className="row row-cols-1 row-cols-lg-2 align-items-end p-0 m-0">
                                <div className="col px-0 pb-4 pb-lg-0">
                                    <img src={item?.image || "https://images.pexels.com/photos/7562349/pexels-photo-7562349.jpeg?auto=compress&cs=tinysrgb&w=600"} alt="" className='w-100' />

                                </div>
                                <div className="col px-5">
                                    <h6>{item?.category}</h6>
                                    <h2 className=' mb-3' style={{ color: '#0d004a' }}>
                                        {item.title || "Title Heading 2"}
                                    </h2>
                                    <p>
                                        {item?.description || "lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim ven non proident."}
                                    </p>
                                    {
                                        item?.link && item?.linkText && 
                                        <Link to={item?.link || "#"} className='text-decoration-none fs-5 fw-bold'>{item?.linkText || "See Plans & Pricing"} <i classname="fa-solid fa-arrow-up-right-from-square"></i></Link>
                                    }

                                </div>
                            </div>
                        </SwiperSlide>
                    ))
                }


            </Swiper>

            <div className="card-slider-2-controls">
                <div className="container">
                    <div className="row justify-content-between px-lg-5">
                        <div className="col">
                            {
                                isAutoplayRunning ? (
                                    <button
                                        className="btn btn-warning btn-lg rounded-0"
                                        onClick={handlePause}
                                    >
                                        <i className="fa-solid fa-pause"></i>
                                    </button>
                                ) : (
                                    <button
                                        className="btn btn-warning btn-lg rounded-0"
                                        onClick={handlePlay}
                                    >
                                        <i className="fa-solid fa-play"></i>
                                    </button>
                                )
                            }

                        </div>
                        <div className="col d-flex justify-content-end align-items-center">
                            <button
                                className="btn btn-warning btn-lg rounded-0"
                                onClick={handlePrev}
                            >
                                <i className="fa-solid fa-arrow-left"></i>
                            </button>
                            <span className="px-3 fs-5 fw-bold">
                                {currentSlide}/{data.length}
                            </span>
                            <button
                                className="btn btn-warning btn-lg rounded-0"
                                onClick={handleNext}
                            >
                                <i className="fa-solid fa-arrow-right"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CardSlider2